import { authGuard } from './core/guards/auth.guard';
import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then((c) => c.HomeComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/auth/signup/signup.component').then((c) => c.SignupComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.component').then(
        (c) => c.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.component').then(
        (c) => c.ResetPasswordComponent,
      ),
  },

  // account revalidation from 1.0
  {
    path: 'verify',
    loadComponent: () =>
      import('./pages/auth/verify-identity/verify-identity').then((c) => c.VerifyIdentity),
  },
  {
    path: 'complete-verification',
    loadComponent: () =>
      import('./pages/auth/set-password-after-verification/set-password-after-verification').then(
        (c) => c.SetPasswordAfterVerification,
      ),
  },

  {
    path: 'verify-email',
    loadComponent: () =>
      import('./pages/auth/verify-email/verify-email.component').then(
        (c) => c.VerifyEmailComponent,
      ),
  },
  {
    path: 'timetable',
    loadComponent: () =>
      import('./pages/timetable/timetable.component').then((c) => c.TimetableComponent),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then((c) => c.PrivacyComponent),
  },
  {
    path: 'delete-account',
    loadComponent: () =>
      import('./pages/delete-account/delete-account.component').then(
        (c) => c.DeleteAccountComponent,
      ),
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./pages/terms-of-service/terms-of-service.component').then(
        (c) => c.TermsOfServiceComponent,
      ),
  },
  {
    path: '',
    loadChildren: () => import('./pages/main/main.routes'),
    canActivate: [authGuard],
  },
];
